/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://dshszqqz45eh3eckqmova66gfi.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-gpwemomgonb27cybb2tcm7knai",
    "aws_cloud_logic_custom": [
        {
            "name": "api729b5b04",
            "endpoint": "https://huu9t1rvd8.execute-api.eu-west-2.amazonaws.com/main",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:a4c17f2e-0b30-489d-9f87-187747618028",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_dJX31GmVW",
    "aws_user_pools_web_client_id": "16kau03am8vv4hq81jdnka71s7",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
